import React from 'react'
import UploadStore from '../../stores/upload-store'
import AdobeAnalytics from '../../utils/adobe-analytics'
import OrderStore from '../../stores/order-store'
import createReactClass from 'create-react-class'


function uploadData() {
	return UploadStore.getData();
}

function orderData() {
	return OrderStore.getItems();
}

var OpeOrderProgress = createReactClass({
	getInitialState: function () {
		return {upload: uploadData(), items: orderData()};
	},
	componentWillMount: function() {
    	UploadStore.addChangeListener(this._onChange);
    	OrderStore.addChangeListener(this._onChange);
  	},

    componentWillUnmount: function() {
        UploadStore.removeChangeListener(this._onChange);
        OrderStore.removeChangeListener(this._onChange);
    },
    _onChange: function () {
        this.setState({upload: uploadData(), items: orderData()});
    },
	getDefaultProps: function() {
		return {
			progressActiveStates: [false, false, false]
		}
	},
	isActive: function (index) {
		return this.props.progressActiveStates[index];
	},

	isDisabled: function (index) {
		switch (index) {
			case 0:
				return false;
			break;
			case 1:
				return !(this.state.items.length > 0);
			break;
			case 2:
				if(this.state.upload.totalImagesRegistered === 0) {
					return true;
				}
				else {
					return !(this.state.upload.totalImagesToUpload === this.state.upload.totalImagesRegistered);
				}
			break;
		}
	},
	goToSelector: function () {
		window.location.hash = "#/selector";
	},
	goToEditor: function () {
		if (!this.isDisabled(1)) {
			window.location.hash = "#/editor";
		}
	},
	goToUpsale: function () {
		if (!this.isDisabled(2)) {
			window.location.hash = "#/upsale";
		}
	},
	render: function() {
		return (
			<div className="row">
				<div className="small-12 columns">
					<div className="steps-wrapper small-12 medium-12 large-12 columns">
						<div onClick={this.goToSelector} style={{cursor: 'pointer'}} id="step-1" className={'step small-4 text-center columns' + (this.isActive(0) ? ' step-active' : ' step-disabled') + (this.props.progressActiveStates[0] ? ' step-current' : '')}>
							<div className="num">1</div>
							<div className="txt">
									<span>{_("Add photos")}</span>
							</div>
						</div>

						<div onClick={this.goToEditor} style={{cursor: 'pointer'}} id="step-2" className={'step small-4 text-center columns' + (this.isActive(1) ? ' step-active' : ' step-disabled') + (this.props.progressActiveStates[1] ? ' step-current' : '') }>
							<div className="num">2</div>
							<div className="txt">
									<span>{_("Options")}</span>
							</div>
						</div>
						<div onClick={this.goToUpsale} style={{cursor: 'pointer'}} id="step-3" className={'step small-4 text-center columns' + (this.isActive(2) ? ' step-active' : ' step-disabled') + (this.props.progressActiveStates[2] ? ' step-current' : '')}>
							<div className="num">3</div>
							<div className="txt">
								<span>{_("Extras")}</span>
							</div>
						</div>
					</div>
				</div>
			</div>

		);
	}
});

export default OpeOrderProgress;
